exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1dmA_0BhpVfjDl{background-color:#ebecf0;border-radius:4px;color:#6b778c;height:24px;justify-content:center;padding:8px}._1bi5JlPrQ4AYXd,._1dmA_0BhpVfjDl{align-items:center;display:flex;margin:-8px 8px 40px}._1bi5JlPrQ4AYXd{border-top:1px solid #ebecf0;flex-direction:column;padding:16px}._2mT5R5WZZke6W4{display:block}._29qlGqAtw4ogC3{font-size:16px;font-weight:700;margin-top:12px}._8OXDo6gtSdwk4G{color:#6b778c}", ""]);

// exports
exports.locals = {
	"empty": "_1dmA_0BhpVfjDl",
	"emptyToday": "_1bi5JlPrQ4AYXd",
	"image": "_2mT5R5WZZke6W4",
	"title": "_29qlGqAtw4ogC3",
	"subtitle": "_8OXDo6gtSdwk4G"
};